var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MdtStatusButtons',{attrs:{"items":_vm.statusTabs},on:{"input":_vm.setActive},model:{value:(_vm.selectedTab),callback:function ($$v) {_vm.selectedTab=$$v},expression:"selectedTab"}})
}
var staticRenderFns = []

export { render, staticRenderFns }